var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("ryoma--" + _vm.type),domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){$event.preventDefault();return _vm.startFunnel($event)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }